<div class="modal-header bg-tertiary">
  <h6 class="modal-title fw-bold" id="salesModalLabel">Transactional details</h6>
  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
  <div class="table-responsive">
    <table class="table table-hover table-striped align-middle">
      <thead>
      <tr>
        <th>Key</th>
        <th>Value</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
        @for (param of params; track param) {
          <tr>
            <td>
              <input type="text" class="form-control" [(ngModel)]="param[0]">
            </td>
            <td>
              <input type="text" class="form-control" [(ngModel)]="param[1]">
            </td>
            <td>
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="remove(param)" appConfirm>
                <i class="bi bi-trash"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="text-end">
    <button type="button" class="btn btn-sm btn-primary" (click)="add()">
      <i class="bi bi-plus-circle"></i>
    </button>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-primary fw-bold" data-bs-dismiss="modal">Cancel</button>
  <button (click)="submit()" type="button" class="btn btn-primary fw-bold">Apply</button>
</div>
